import { Link } from 'react-router-dom';
import '../Buttons/Buttons.css';

const isExternal = (url) => /^https?:\/\//i.test(url);

const Button = ({ text, page, href, type = 'button', disabled = false, className = '' }) => {
  const destination = href || page;

  if (destination && isExternal(destination)) {
    return (
      <div className={`main-button ${className}`}>
        <a
          href={destination}
          target="_blank"
          rel="noopener noreferrer"
          className="btn-link"
        >
          {text}
        </a>
      </div>
    );
  }

  if (destination) {
    return (
      <div className={`main-button ${className}`}>
        <Link to={destination} className="btn-link">
          {text}
        </Link>
      </div>
    );
  }

  return (
    <div className={`main-button ${className}`}>
      <button type={type} disabled={disabled} className="btn-link">
        {text}
      </button>
    </div>
  );
};

export default Button;
